define('components/course/models/slide-type/content',[
    'components/course/models/slide-type/base'
], function (Base) {
    "use strict";

    return Base;
});

